import { FormGroupGrid } from "components/GridForm";
import { AppReferenceManyField } from "components/list/AppReferenceManyField";
import React from "react";
import { useTranslate } from "react-admin";

import { OrderProductArticlesList } from "../OrderProductArticles";

export const OrderProductArticlesBlock = ({
	orderId,
	pallets,
	companyId,
	status,
	totalBoxes,
	...props
}) => {
	const translate = useTranslate();
	return (
		<FormGroupGrid title={translate("resources.orders.block-label.order-product-articles")}>
			<AppReferenceManyField
				label={"order-product-articles"}
				fullWidth
				reference="order-product-articles"
				target="order_id"
				filter={{ no_range: true }}
				pagination={false}
			>
				<OrderProductArticlesList
					orderId={orderId}
					pallets={pallets}
					companyId={companyId}
					status={status}
					totalBoxes={totalBoxes}
				/>
			</AppReferenceManyField>
		</FormGroupGrid>
	);
};
